import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { concat, merge, of, from, Subscription, Subject } from 'rxjs';
import { map, switchMap, concatMap, filter, debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { Document, DocItems, DocInheritanceRule } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'

import { ProductApiService } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { RestApiService } from '../../services/rest-api.service';

@Component({
  selector: 'app-new-document-dlg-process-shipment',
  templateUrl: './new-document-dlg-process-shipment.component.html',
  styleUrls: ['./new-document-dlg-process-shipment.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessShipmentComponent implements OnInit, OnChanges, OnDestroy {

  private globalSettinsData: GlobalSettingsData;
  private _productInfoQuery: Subscription;

  /*
   * Consider that parentDocument may have or may NOT have items property filled with [actual] docItems
   */
  @Input() parentDocument: Document;

  /*
   * Therefore, to keep source object untouched (immutable ????)
   * we will expect alone/independent copy of DocItems as Input parameter
   * 
   */

  @Input() docItems: DocItems[];

  @Input() newDocument: Document;

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number;

  count: number = -1;

  sourceDocItems: DocItems[];

  @Input() countEmptyDocItems: boolean = false;

  @Output() blocking: EventEmitter<boolean> = new EventEmitter();

  actions =
    [
      { name: 'Удалить существующие позиции', value: 3, disabled: false },
      { name: 'Отгружать только товары в наличии', value: 4, disabled: false },
      { name: 'Учитывать пустые строки', value: 10, disabled: false },
    ];

  selectedActions: any = [3, 4];

  public get allowIgnoreStock(): boolean { return !this.selectedActions.includes(4); }

  private listOptions$ = new Subject<number>();
  private currencyQuery: Subscription;

  constructor(
    private restApi: RestApiService,
    private prodApi: ProductApiService,
    private docApi: DocumentApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  round2(n: number) {
    return Math.round((n * 100)) / 100;
  }

  round1(n: number) {
    return Math.round((n * 10)) / 10;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgProcessShipmentComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'newDocument':
          if (this.newDocument) {
            this.processDocItems();
          }
          break;

        case 'docItems':
          if (this.docItems) {
            this.sourceDocItems = [... this.docItems];
            this.count = this.sourceDocItems.length;
            this.processDocItems();
          }
          break;

        case 'parentDocument':
          if (this.parentDocument) {

            if (this.parentDocument.items) {
              this.processDocItems();
            }
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessShipmentComponent in ngOnDestroy')

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }

    if (this._productInfoQuery) { this._productInfoQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessShipmentComponent in ngOnInit');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
    /*
     * Get Actual currency rate for newDocument
     * Those one in newDocument.DOCRATEVAL from createNewDocument Dialog would arrive later
     * 
     */
    let rowSortIndex = 0;
    this.currencyQuery =
      this.listOptions$.pipe(
        debounceTime(50),
        switchMap(currid => this.restApi.getCurrencyInfoByID(currid).pipe(

          concatMap(rate => {

            this.blocking.emit(true);

            this.newDocument.DOCRATEVAL = rate[0].CURRATE;
            this.newDocument.items = [];

            rowSortIndex = 0;
            return from(this.sourceDocItems).pipe(
              concatMap(di => of({
                ...di,
                ... {
                  DOCITEMID: -2,
                  cloneIndex: 0,
                  U4ETKA: null,
                  DOCITEMCURRID: this.newDocument.DOCCURRID,
                  DOCITEMCRATE: this.newDocument.DOCRATEVAL,

                  PRODVAT: di.PRODVAT ?? this.globalSettinsData.vatValue,
                  DOCITEMPRICE: di.DOCITEMPRICE,
                  DOCITEMVPRICE: di.DOCITEMPRICE / this.newDocument.DOCRATEVAL,
                  DOCITEMQTY: di.DOCITEMQTY - (di.DOCITEMSHIPPED ?? 0),
                  DOCITEMSUM: di.DOCITEMPRICE * (di.DOCITEMQTY - (di.DOCITEMSHIPPED ?? 0))
                }
              })),

              filter(di => (di.DOCITEMQTY > 0)),

              concatMap(di => this.prodApi.getProdInfoById(
                di.PRODID,
                this.newDocument.DOCMANCLIID,
                this.newDocument.DOCCURRID,
                this.globalSettinsData.mainStockId,
                this.globalSettinsData.impCountFlag ? this.globalSettinsData.impStockId : 0,
                this.globalSettinsData.auxCountFlag ? this.globalSettinsData.auxStockId : 0,
                this.newDocument.DOCDATE
              ).pipe(map(data => {
                di.prodInfo = data[0];
                environment.production || console.log('*** NewDocumentDlgProcessShipmentComponent getProdInfoById: ' + JSON.stringify(di.prodInfo));

                // Adjust DOCITEMQTY according to stock availability and allowIgnoreStock flag
                // If allowIgnoreStock is false, then we must ship at least available stock (if any)
                // If allowIgnoreStock is true, then we ship as requested (DOCITEMQTY)
                if (!this.allowIgnoreStock) {
                  di.DOCITEMQTY = Math.min(di.DOCITEMQTY, di.prodInfo.PRODSTOCK);
                }
                if (di.DOCITEMQTY > 0) {
                  this.newDocument.items.push({ ...di, PAYITEMCLIID: (rowSortIndex += 10) });
                }
              }))),

              finalize(() => {
                this.blocking.emit(false);
              })
            );
          }),
        ))
      )
        .subscribe();

    this.processDocItems();
  }

  processDocItems() {
    console.log('*** NewDocumentDlgProcessShipmentComponent in processDocItems');
    this.listOptions$.next(this.newDocument.DOCCURRID);
  }

  onDocTypeChanges(event) {
    console.log('*** NewDocumentDlgProcessShipmentComponent onDocTypeChanges ' + JSON.stringify(event));

    this.processDocItems();
  }

  onClearRows(event) {
    console.log('*** NewDocumentDlgProcessShipmentComponent onClearRows ' + JSON.stringify(event));

    this.newDocument.items = [];
  }

  onRefreshRows(event) {
    console.log('*** NewDocumentDlgProcessShipmentComponent onRefreshRows ' + JSON.stringify(event));

    this.processDocItems();
  }
}
